<template>
  <div
    v-if="selectedSegment?.loading || selectedSegment?.loaded"
    class="row items-center q-mb-sm"
  >
    <span class="text-h5">Segment Details</span>
    <q-spinner
      v-if="selectedSegment?.loading"
      size="sm"
      class="q-ml-sm"
    />
  </div>
  <template v-if="selectedSegment?.loaded && !selectedSegment?.loading">
    <div
      class="text-subtitle2 text-bold q-my-sm"
    >
      Segment Conditions
    </div>
    <segment-conditions :conditions="selectedSegment?.conditions" />
  </template>
  <template v-if="selectedSegment?.loaded && !selectedSegment?.loading">
    <div class="q-ma-md">
      <q-chip
        v-if="!$_.isNil(selectedSegment?.memberCount)"
        square
        class="text-bold"
      >
        {{ selectedSegment?.memberCount }} Users
      </q-chip>
      <q-chip
        v-for="(tag, index) in selectedSegment?.tags"
        :key="index"
      >
        {{ tag }}
      </q-chip>
    </div>
  </template>
  <template v-if="selectedSegment?.loaded && !selectedSegment?.loading">
    <div
      v-if="!$_.isEmpty(selectedSegment?.description)"
      class="text-subtitle2 q-mb-sm"
    >
      Description
    </div>
    <div>
      {{ selectedSegment?.description }}
    </div>
  </template>
</template>

<script>
import SegmentConditions from 'src/modules/admin/customerio/SegmentConditions'

export default {
  name: 'SegmentDetails',
  components: {
    SegmentConditions
  },
  props: {
    selectedSegment: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>
